import * as React from 'react';
import classNames from 'classnames';
import fr from 'date-fns/locale/fr';
import PropTypes from 'prop-types';
import ReactDatePicker, { ReactDatePickerProps, registerLocale } from 'react-datepicker';
import { useSession } from '@hooks';
import 'react-datepicker/dist/react-datepicker.css';
registerLocale('fr', fr)

interface DateRangePickerProps extends ReactDatePickerProps {
  additionalClassname?: string
};

const languagesVarsCodes = [
  "LANG_neobooking_datepicker_format_placeholder", //JJ/MM/AAAA
]

const DateRangePicker: React.FC<DateRangePickerProps> = ({ additionalClassname, ...props }) => {

  const { languagesVars } = useSession();

  const defaultClass = "tw-rounded tw-border tw-border-gray-300 focus:tw-border-primary-500 tw-outline-none tw-py-1 tw-px-3 tw-leading-8 tw-bg-white tw-transition-colors tw-duration-200 tw-ease-in-out";
  let customClass = defaultClass;

  if (props.className) {
    customClass = props.className;
  } else {
    customClass = classNames(defaultClass, additionalClassname)
  }

  return <>
    <ReactDatePicker
      selectsRange={true}
      dayClassName={() => "react-datepicker-day-custom"}
      autoComplete="off"
      className={customClass}
      locale={"fr"}
      dateFormat={"dd/MM/yyyy"}
      {...props}
    />
  </>;
};

DateRangePicker.propTypes = {
  //
};

export default DateRangePicker;
